<template>
  <base-map
    :center="nowCenter"
    @updateCenter="updateCenter"
    @click="onReset"
  >
    <template>
      <base-marker
        v-if="selectedFlag"
        :lat-lng="selectedCenter"
        :tooltip="selectedInfo[locale]"
        color="black"
      >
      </base-marker>
    </template>
    <template v-for="(ifsc, ifscIndex) in ifscInfo">
      <base-marker
        v-if="options.marker"
        v-for="address in ifsc.address"
        :lat-lng="getLatLng(address.location.coordinates)"
        :popup="address[locale]"
        :tooltip="ifsc.name[locale]"
        color="blue"
      >
      </base-marker>
      <base-polygon-group
        :boundaries="ifsc.serviceArea"
        :popup="ifsc.name[locale]"
        :tooltip="ifsc.name[locale]"
        @click="onClick(ifsc)"
        v-if="options.area"
        />
    </template>
  </base-map>
</template>

<script>
import common from '@/mixins/common.js'

import { Main } from '@/event-bus/main.js'

import { BaseMap, BaseMarker, BasePolygonGroup } from "@/components/Map";

const CentreType = Object.freeze({
  "IFSC": "IFSC",
  "NEC": "NEC",
  "DECC": "DECC",
  "SSFU": "SSFU"
});

export default {
  name: "ServiceMap",
  mixins: [common],
  components: {
    BaseMap,
    BaseMarker,
    BasePolygonGroup,
  },
  props: {
    // BaseMap Properties
    center: {
      type: [Object, Array],
      default: () => [22.28552, 114.15769]
    },
    options: {
      type: Object,
      default: () => {
        return {
          marker: true,
          area: true
        };
      }
    },
  },
  data: function() {
    return {
      ifscInfo: [],
      nowCenter: this.center,
      selectedCenter: this.center,
      selectedInfo: null,
      selectedFlag: false,
    }
  },
  methods: {
    initEvent() {
      Main.$on('select', payload => {
        this.onSelect(payload);
      });
      Main.$on('toCenter', payload => {
        this.onToCenter(payload);
      });
      Main.$on('reset', () => {
        this.onResetFromInfoPanel();
      });
    },
    // Convert MongoDB GeoJSON to LatLng
    getLatLng: function(coordinates) {
      return [coordinates[1], coordinates[0]];
    },
    loadCentreInfo: function(type) {
      this.$store.dispatch("map/getCentreInfo", { type: type }).then(res => {
        this.ifscInfo = res;
      });
    },
    onClick(payload) {
      this.$emit('click', payload);
    },
    onResetFromInfoPanel() {
      this.selectedFlag = false;
    },
    onReset() {
      if(!this.selectedFlag) {
        this.$emit('reset');
      }
    },
    onSelect(payload) {
      this.selectedCenter = [payload.lat, payload.lng];
      this.nowCenter = [payload.lat, payload.lng];
      this.selectedInfo = payload;
      this.selectedFlag = true;
      this.findCenter();
    },
    onToCenter(payload) {
      this.nowCenter = [payload.lat, payload.lng];
    },
    
    findCenter() {
      var resultInfo = null;
      this.ifscInfo.forEach(ifsc => {
        ifsc.serviceArea.forEach(area => {
          var result = this.isInside([this.nowCenter[1], this.nowCenter[0]], area.coordinates[0]);
          if(result) {
            resultInfo = Object.assign({}, ifsc, { selected: true, valid: true, info: this.selectedInfo });
          }
        })
      })
      if(resultInfo !== null) {
        this.onClick(resultInfo);
      } else{
        this.onClick({ selected: true, valid: false, info: this.selectedInfo });
      }
    },
    updateCenter(payload) {
      this.nowCenter = [payload.lat, payload.lng];
    },
    
    isInside(point, vs) {
      var x = point[0], y = point[1];

      var inside = false;
      for (var i = 0, j = vs.length - 1; i < vs.length; j = i++) {
        var xi = vs[i][0], yi = vs[i][1];
        var xj = vs[j][0], yj = vs[j][1];

        var intersect = ((yi > y) != (yj > y))
            && (x < (xj - xi) * (y - yi) / (yj - yi) + xi);
        if (intersect) inside = !inside;
      }

      return inside;
    },
  },
  mounted() {
    this.loadCentreInfo(CentreType.IFSC);
    this.initEvent();
  }
}
</script>

<style>
</style>
